import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MODAL_TOKEN, ModalProvider } from '@core';

@Component({
  selector: 'lib-push-invite-players',
  templateUrl: './push-invite-players.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class PushInvitePlayersComponent {
  private readonly modalProvider: ModalProvider = inject(MODAL_TOKEN);

  closeModal(): void {
    this.modalProvider.dismissAllStoredModals();
  }
}
